import ProductTags from './ProductTags.vue'

export default ProductTags
